<template>
    <div class="form-container">
        <h2>{{ isEditing ? 'Edit' : 'Add' }} Phase Schedule</h2>
        <hr>

        <div v-if="errorMessage" class="error-message">
            <p>{{ errorMessage }}</p>
        </div>

        <form @submit.prevent="submitForm">
            <label>Name <span class="required">*</span></label>
            <input type="text" v-model="phase.name" placeholder="Phase Name" required />
            <div v-if="errors.name" class="error-message">{{ errors.name[0] }}</div>

            <label>Minimum Days <span class="required">*</span></label>
            <input type="number" v-model="phase.min_days" min="0" placeholder="Min Days" required />
            <div v-if="errors.min_days" class="error-message">{{ errors.min_days[0] }}</div>

            <label>Maximum Days <span class="required">*</span></label>
            <input type="number" v-model="phase.max_days" min="0" placeholder="Max Days" required />
            <div v-if="errors.max_days" class="error-message">{{ errors.max_days[0] }}</div>

            <label>Description</label>
            <textarea v-model="phase.description" rows="3" placeholder="Optional Description"></textarea>
            <div v-if="errors.description" class="error-message">{{ errors.description[0] }}</div>

            <div class="btn-group mt-4">
                <button type="submit" class="btn btn-sm">
                    {{ isEditing ? 'Update' : 'Add' }}
                </button>
                <button type="button" class="btn btn-sm cancel-btn" @click="$router.push('/dashboard/phase-schedules')">
                    Cancel
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            phase: {
                name: '',
                min_days: '',
                max_days: '',
                description: '',
            },
            isEditing: false,
            errorMessage: null,
            errors: {},
        };
    },
    methods: {
        async submitForm() {
            this.errorMessage = null;
            this.errors = {};

            try {
                if (this.isEditing) {
                    await this.$api.put(`/phase-schedules/${this.id}`, this.phase);
                } else {
                    await this.$api.post('/phase-schedules', this.phase);
                }
                this.$router.push('/dashboard/phase-schedules');
            } catch (error) {
                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    this.errorMessage = 'An error occurred while saving the phase schedule. Please try again later.';
                }
            }
        },
        async fetchPhase() {
            if (this.id) {
                this.isEditing = true;
                try {
                    const res = await this.$api.get(`/phase-schedules/${this.id}`);
                    this.phase = res.data;
                } catch (error) {
                    this.errorMessage = 'Error fetching phase schedule.';
                }
            }
        },
    },
    mounted() {
        this.fetchPhase();
    },
};
</script>

<style scoped>
.form-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.error-message {
    color: red;
    margin-top: 5px;
}

.btn-group {
    display: flex;
    gap: 10px;
}

.required {
    color: red;
}

textarea {
    width: 100%;
    resize: vertical;
    padding: 8px;
}
</style>
